<div class="w-100" [ngClass]="{ 'absolute z-index-3 top-0': isAbsolutePosition }">
  <div
    class="widget-tag w-fit m-a p-2 px-3 bold layout-auto-fr align-items-center gap-2"
    [ngClass]="variant">
    <div>
      <shared-icon height="0.75rem" width="0.75rem" [icon]="icon" />
    </div>
    <div class="text-14">{{ text }}</div>
  </div>
</div>
